import {toast} from "react-toastify";

export const Logout = () => {
    window.localStorage.removeItem("gd-auth");
    window.localStorage.removeItem("user_meta");
    toast('Logout Successful!');
    window.location.pathname = "/";
    return true;
};